/*
 * @Author: linwl 1015547748@qq.com
 * @Date: 2025-10-14 15:46:26
 * @LastEditors: linwl 1015547748@qq.com
 * @LastEditTime: 2026-01-14 14:01:23
 * @FilePath: \mall\src\utils\aMap\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import AMapLoader from '@amap/amap-jsapi-loader'

const securityJsCode =
  process.env.VUE_APP_AMAP_SECURITY_CODE

window._AMapSecurityConfig = {
  securityJsCode: securityJsCode
}

const aMapKey = process.env.VUE_APP_AMAP_KEY
const aMapSecurityCode =
  process.env.VUE_APP_AMAP_SECURITY_CODE

// 缓存高德地图实例
let aMapInstance = null
let aMapLoadingPromise = null

// 初始化地图（单例模式）
const aMap = async () => {
  // 如果已有实例，直接返回
  if (aMapInstance) {
    return aMapInstance
  }

  // 如果正在加载中，等待加载完成
  if (aMapLoadingPromise) {
    return aMapLoadingPromise
  }

  window._AMapSecurityConfig = {
    securityJsCode: aMapSecurityCode
  }

  // 开始加载，缓存 Promise 避免重复请求
  aMapLoadingPromise = AMapLoader.load({
    key: aMapKey, // 申请好的Web端开发者Key，首次调用 load 时必填
    plugins: [
      // 'AMap.Scale',
      'AMap.Geolocation',
      'AMap.CitySearch',
      'AMap.Geocoder',
      'AMap.convertFrom'
    ] //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
  })
    .then(AMap => {
      aMapInstance = AMap
      return AMap
    })
    .catch(err => {
      // 加载失败时清除 Promise，允许重试
      aMapLoadingPromise = null
      throw err
    })

  return aMapLoadingPromise
}

const location = async () => {
  const AMap = await aMap()

  const geolocation = new AMap.Geolocation({
    enableHighAccuracy: true, // 是否使用高精度定位，默认:true
    timeout: 10000, // 超过10秒后停止定位，默认：5s
    buttonPosition: 'RB', // 定位按钮的停靠位置
    buttonOffset: new AMap.Pixel(10, 20), // 定位按钮距离对应角落的距离
    zoomToAccuracy: true, // 定位成功后是否自动调整地图视野到相应级别
    noIpLocate: false, // 默认不使用ip精确定位
    noGeoLocation: false, // 默认不使用浏览器定位
    showButton: true, // 设置定位按钮是否显示
    showMarker: true, // 定位成功后在定位位置显示点标记，默认：true
    showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
    getCityWhenFail: true

    // timeout: 5000, // 增加超时时间到5秒
    // convert: false,
    // GeoLocationFirst: true // 优先使用GPS定位
  })

  return geolocation
}

const SearchCity = async (cityName = '') => {
  const AMap = await aMap()
  const Geocoder = new AMap.Geocoder()
  return Geocoder
}

const getCityconvertFrom = async ({ lat, lng }) => {
  const Amap = await aMap()
  const convertFrom = new Amap.convertFrom(
    `${lng},${lat}`,
    (status, result) => {
      resolve(status, result)
    }
  )
  return convertFrom
}

const LocalCity = async () => {
  try {
    const Amap = await aMap()
    const citySearch = new Amap.CitySearch()
    return citySearch
  } catch (error) {
    console.error(error)
  }
}

export {
  aMap,
  location,
  SearchCity,
  getCityconvertFrom,
  LocalCity
}
